<template>
  <vs-popup class="update-rm-order-pop-up"
            title="UPDATE SUNDRY ITEM ORDER DETAILS"
            @close="onClickClose()"
            :active.sync="open"
            :buttons-hidden="true">

    <vx-card no-shadow id="rm-order-details-update-popup">
      <ValidationObserver ref="form" v-slot="{ handleSubmit }">
        <form @submit.prevent="handleSubmit(onClickUpdateSundryItemOrder)" autocomplete="off">
          <span>
           <div class="vx-row mb-3">
            <div class="vx-col md:w-1/2 w-full md:mb-0">
              <ValidationProvider vid="line1" name="line1" rules="required" v-slot="{ errors }">
                <small class="label">Address Line 1</small>
                <vs-input v-model="createForm.line1"  name="line1" class="w-full" label="" :danger="!!errors[0]" :danger-text="errors[0]" val-icon-danger="icon-x" val-icon-pack="feather"/>
              </ValidationProvider>
            </div>
            <div class="vx-col md:w-1/2 w-full md:mb-0">
              <ValidationProvider vid="line2" name="line2" rules="" v-slot="{ errors }">
                <small class="label">Address Line 2</small>
                <vs-input v-model="createForm.line2"  name="line2" class="w-full" label="" :danger="!!errors[0]" :danger-text="errors[0]" val-icon-danger="icon-x" val-icon-pack="feather"/>
              </ValidationProvider>
            </div>
          </div>
           <div class="vx-row mb-3">
            <div class="vx-col md:w-1/2 w-full md:mb-0">
              <ValidationProvider vid="line3" name="line3" rules="" v-slot="{ errors }">
                <small class="label">Address Line 3</small>
                <vs-input v-model="createForm.line3"  name="line3" class="w-full" label="" :danger="!!errors[0]" :danger-text="errors[0]" val-icon-danger="icon-x" val-icon-pack="feather"/>
              </ValidationProvider>
            </div>
            <div class="vx-col md:w-1/2 w-full md:mb-0">
              <ValidationProvider vid="town_state" name="town_state" rules="required" v-slot="{ errors }">
                <small class="label">Town / State</small>
                <vs-input v-model="createForm.town_state"  name="town_state" class="w-full" label="" :danger="!!errors[0]" :danger-text="errors[0]" val-icon-danger="icon-x" val-icon-pack="feather"/>
              </ValidationProvider>
            </div>
          </div>
           <div class="vx-row mb-3">
            <div class="vx-col md:w-1/2 w-full md:mb-0">
              <ValidationProvider vid="post_code" name="post_code" rules="required" v-slot="{ errors }">
                <small class="label">Postal Code</small>
                <vs-input v-model="createForm.post_code"  name="post_code" class="w-full" label="" :danger="!!errors[0]" :danger-text="errors[0]" val-icon-danger="icon-x" val-icon-pack="feather"/>
              </ValidationProvider>
            </div>
            <div class="vx-col md:w-1/2 w-full md:mb-0">
              <ValidationProvider vid="country" name="country" rules="required" v-slot="{ errors }">
                <small class="label">Country</small>
                <v-select :filter-by="myFilter" :clearable="false" name="country" placeholder=""
                          label="name" v-model="createForm.country" :reduce="option => option.name"
                          :options="countryCodes" :dir="$vs.rtl ? 'rtl' : 'ltr'"/>
                <span class="text-danger text-sm">{{ errors[0] }}</span>
              </ValidationProvider>
            </div>
          </div>
            <div class="vx-row mb-3">
             <div class="vx-col md:w-1/3 w-full md:mb-0">
              <ValidationProvider vid="sage_department" name="sage_department" rules="required" v-slot="{errors}">
                <small class="label">Sage Department</small>
                <v-select :filter-by="myFilter" :clearable="false" name="sage_department" placeholder=""
                          label="name" v-model="createForm.sage_department_id" :reduce="option => option.id"
                          :options="sage_departments" :dir="$vs.rtl ? 'rtl' : 'ltr'"/>
                <span class="text-danger text-sm">{{ errors[0] }}</span>
              </ValidationProvider>
             </div>
             <div class="vx-col md:w-1/3 w-full md:mb-0">
              <ValidationProvider vid="region" name="region" rules="required" v-slot="{errors}">
                <small class="label">Region</small>
                <v-select :filter-by="myFilter" :clearable="false" name="region" placeholder=""
                          label="name" v-model="createForm.region_id" :reduce="option => option.id"
                          :options="regions" :dir="$vs.rtl ? 'rtl' : 'ltr'"/>
                <span class="text-danger text-sm">{{ errors[0] }}</span>
              </ValidationProvider>
             </div>
              <div class="vx-col md:w-1/3 w-full md:mb-0">
                    <ValidationProvider vid="required_by" name="required_by" rules="required" v-slot="{ errors }">
                        <small class="label">Required By Date</small>
                        <flat-pickr class="w-full"
                                    style="display: none"
                                    :config="{ dateFormat: 'd/m/Y'}"
                                    v-model="createForm.required_by"
                                    placeholder="Choose Date"
                        />
                      <flat-pickr class="w-full"
                                  :config="{ dateFormat: 'd/m/Y'}"
                                  v-model="createForm.required_by"
                                  placeholder="Choose Date"
                      />
                        <span class="text-danger text-sm">{{ errors[0] }}</span>
                    </ValidationProvider>
              </div>
            </div>
          </span>
          <div class="vx-row mb-3">
            <div class="vx-col w-full">
              <ValidationProvider vid="delivery_instruction" name="delivery_instruction" rules="" v-slot="{ errors }">
                <small class="label">Delivery Instructions</small>
                <vs-textarea class="mb-0" v-model="createForm.delivery_instruction" height="120px" />
                <span class="text-danger text-xs mt-0">{{ errors[0] }}</span>
              </ValidationProvider>
            </div>
          </div>

          <div class="vx-row mb-3">
            <div class="vx-col w-full">
              <ValidationProvider vid="note" name="note" rules="" v-slot="{ errors }">
                <small class="label">Note</small>
                <vs-textarea class="mb-0" v-model="createForm.note" height="120px" />
                <span class="text-danger text-xs mt-0">{{ errors[0] }}</span>
              </ValidationProvider>
            </div>
          </div>

          <vx-card subtitle="Additional Cost" cardBorder>
            <div class="vx-row mb-3" v-for="(cost, cost_index) in createForm.additional_costs" :key="cost_index">
              <div class="vx-col md:w-2/5 w-full md:mb-0">
                <ValidationProvider :vid="cost_index+'name'" :name="cost_index+'name'" rules="required" v-slot="{ errors }">
                  <small class="label">Details</small>
                  <vs-input v-model="cost.name"  name="name" class="w-full" label="" :danger="!!errors[0]" :danger-text="errors[0]" val-icon-danger="icon-x" val-icon-pack="feather"/>
                </ValidationProvider>
              </div>
              <div class="vx-col md:w-2/5 w-full md:mb-0">
                <ValidationProvider :vid="cost_index+'amount'" :name="cost_index+'amount'" rules="required" v-slot="{ errors }">
                  <small class="label">Value ({{ sundry_supplier_currency }})</small>
                  <vs-input v-model="cost.amount"  name="amount" class="w-full" label="" :danger="!!errors[0]" :danger-text="errors[0]" val-icon-danger="icon-x" val-icon-pack="feather"/>
                </ValidationProvider>
              </div>
              <div class="vx-col md:w-1/5 w-full md:mb-0">
                <small class="label">&nbsp;</small>
                <vs-button @click.stop="onClickRemoveCost(cost_index)" size="small" color="danger" class="mt-2 ml-4">Remove</vs-button>
              </div>
            </div>
            <div class="vx-row">
              <vs-button @click.stop="onClickAddNewCost" size="small" class="mt-4 ml-4">+ Add</vs-button>
            </div>
          </vx-card>

          <div class="flex flex-wrap items-center justify-end mt-8">
            <vs-button button="submit" class="ml-auto mt-2">Save Changes</vs-button>
            <vs-button @click="createForm = {}" class="ml-4 mt-2" type="border" color="warning">Reset</vs-button>
          </div>
        </form>
      </ValidationObserver>
    </vx-card>
  </vs-popup>
</template>

<script>
import {RepositoryFactory} from "@/repository/RepositoryFactory";
import vSelect from 'vue-select'
import SuccessMessage from '@/mixins/SuccessMessage'
import ErrorMessages from '@/mixins/ErrorMessages'
import flatPickr from 'vue-flatpickr-component'

const SundrySupplierRepository = RepositoryFactory.get('sundry')
const SupplierManufactureRepository = RepositoryFactory.get('supplierManufacture');
const RegionsRepository = RepositoryFactory.get('regions');
const SageSettingsRepository = RepositoryFactory.get('sage_settings');

function initialState() {
  return {
    id:'',
    open: false,
    createForm: {
      line1: '',
      line2: '',
      line3: '',
      town_state: '',
      post_code: '',
      country: '',
      delivery_instruction:'',
      note: '',
      sage_department_id:'',
      region_id:'',
      additional_costs: [],
    },
    countryCodes:[],
    sage_nominal_codes:[],
    sage_departments:[],
    regions:[],
    sundry_supplier_currency: 'GBP'
  }
}
export default {
  name: "UpdateSundryItemOrderDetailsPopup",
  data(){
    return initialState()
  },
  components: {
    'v-select': vSelect,
    flatPickr
  },
  mixins: [SuccessMessage, ErrorMessages],
  methods:{
    async openPopup (id) {
      this.id = id
      await this.getCountryCodes()
      await this.getSageNominalCodes()
      await this.getSageDepartments()
      await this.getRegions()
      await this.getSundryItemOrderDetails()
      this.open = true
    },
    async getSundryItemOrderDetails() {
      this.$vs.loading()
      try {
        const {data} = (await SundrySupplierRepository.getSundryOrder(this.id)).data
        this.createForm.line1 =  data.line1
        this.createForm.line2 =  data.line2
        this.createForm.line3 =  data.line3
        this.createForm.town_state =  data.town_state
        this.createForm.post_code =  data.post_code
        this.createForm.country =  data.country
        this.createForm.delivery_instruction =  data.delivery_instruction
        this.createForm.note =  data.note
        this.createForm.sage_department_id = data.sage_department.id
        this.createForm.region_id = data.region.id
        this.createForm.required_by = data.required_by
        this.createForm.additional_costs = data.additional_cost
        this.sundry_supplier_currency = data.sundry_supplier_currency
      } catch (e) {
        this.convertAndNotifyError(e)
      }
      this.$vs.loading.close()
      this.dataLoaded= true
    },
    async getCountryCodes() {
      await this.$vs.loading()
      this.countryCodes = (await SupplierManufactureRepository.getCountryCodes()).data.data;
      this.$vs.loading.close()
    },
    async getSageNominalCodes(){
      this.$vs.loading()
      const {data} = await SageSettingsRepository.getListOfSageNominalCodes('','','',0)
      this.sage_nominal_codes =  data.data
      this.$vs.loading.close()
    },
    async getSageDepartments(){
      this.$vs.loading()
      const {data} = await SageSettingsRepository.getListOfSageDepartments('','','',0)
      this.sage_departments =  data.data
      this.$vs.loading.close()
    },
    async getRegions(){
      this.$vs.loading()
      const {data} = await RegionsRepository.getListOfRegions()
      this.regions =  data.data
      this.$vs.loading.close()
    },
    myFilter: (option, label, search) => {
      let temp = search.toLowerCase();
      return option.name.toLowerCase().indexOf(temp) > -1 ||
        option.isd_code.toLowerCase().indexOf(temp) > -1
    },
    async onClickUpdateSundryItemOrder(){
      await this.$vs.loading()
      const vue = this;
      try {
        this.createForm.additional_costs = this.createForm.additional_costs.map((x) => { 
          return { id: x.id ? x.id : null ,name: x.name, amount: Number(x.amount).toFixed(2)}
         })
        await SundrySupplierRepository.updateSundryItemOrder(this.id, this.createForm)
        this.showSuccessMessage('Sundry order updated successfully')
        await vue.$parent.refreshData()
        this.open = false
      }catch (error){
        this.convertAndNotifyError(error)
      }
      this.$vs.loading.close()
    },
    async onClickClose() {
      this.open = false;
    },
    onClickAddNewCost() {
      this.createForm.additional_costs.push({'name' : '', amount: '0.00'})
    },
    onClickRemoveCost(index) {
      this.createForm.additional_costs.splice(index, 1)
    }
  }
}
</script>

<style scoped>
.update-rm-order-pop-up >>> .vs-popup {
  /*min-height: 50% !important;*/
  min-width: 60% !important;
}

</style>
